export function sanatiseHealthCardNumber(unsafe: string): string {
  const nospaces = unsafe.replace(/\s/g, '');
  return nospaces;
}
